import { fromFetch } from 'rxjs/fetch';
import { switchMap } from 'rxjs/operators';
import { getLotMapInventory } from 'constants/routes';

const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.json();
};

/**
 * Fetches the lot map inventory for a community from
 * `GET /ajax/native-interactive-site-map/{communityId}/lot-map-inventory`.
 *
 * Returns a cold Observable — the request is only made when subscribed.
 * Errors are propagated as Observable errors so the epic can handle them
 * with catchError.
 *
 * @param {number} communityId
 * @returns {import('rxjs').Observable<object>}
 */
export function getLotMapInventory$(communityId) {
  return fromFetch(getLotMapInventory(communityId), {
    method: 'GET',
    headers: { Accept: 'application/json' },
  }).pipe(
    switchMap(parseJsonResponse),
  );
}

export default getLotMapInventory$;
